import React from 'react'
import { Card, CardTitle, CardText } from 'material-ui-legacy/Card'

import { MarginFormatter } from '../UI/FormatProviders'
import LinearLoader from '../UI/LinearLoader'
import './styles/quotes.css'

/*
Props:
- quote: a quote object
- style: CSS for the enclosing card (optional)
*/
const QuoteCostSummary = props => {
  const { quote, style } = props
  if (!quote) return <LinearLoader />

  const summary = quote.attributes.formattedSummary
  const cardStyle = style || { marginTop: '40px' }
  const cardTextStyle = {
    display: 'flex',
    justifyContent: 'center'
  }
  const columnStyle = {
    marginRight: '40px'
  }

  return (
    <Card style={cardStyle} className="client-facing-quote-screen">
      <CardTitle
        title="Cost & margin summary"
        subtitle="Internal, not shown to client"
      />

      <CardText style={cardTextStyle}>
        <section style={columnStyle}>
          <p>
            <strong>Gross cost:</strong> {summary.formattedGrossCost}
          </p>
          <p>
            <strong>Gross total:</strong> {summary.formattedGrossTotal}
          </p>
          <p>
            <strong>Gross margin:</strong>{' '}
            <MarginFormatter value={summary.grossMargin * 100} />
          </p>
        </section>
      </CardText>
    </Card>
  )
}

export default QuoteCostSummary



// WEBPACK FOOTER //
// ./src/components/Quotes/QuoteCostSummary.jsx